import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useDocumentMeta } from '@/hooks/useDocumentMeta';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';
import { articles, articleCategories } from '@/mocks/articles';

export default function Articles() {
  const [activeCategory, setActiveCategory] = useState('all');

  useDocumentMeta(
    '资讯中心 - 九游娱乐',
    '九游娱乐资讯中心为您提供最新平台公告、游戏攻略、优惠活动和行业动态。掌握第一手娱乐资讯，畅享更佳游戏体验。'
  );

  const filteredArticles = activeCategory === 'all'
    ? articles
    : articles.filter((a) => a.category === activeCategory);

  const featuredArticle = articles.find((a) => a.isFeatured);

  return (
    <>
      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <section className="pt-24 pb-10 bg-background-100">
            <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
              <Breadcrumb items={[{ label: '资讯中心' }]} />
              <div className="mt-6 mb-2">
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/70 text-primary-700 text-xs font-semibold mb-3">
                  <i className="ri-article-line"></i>
                  资讯中心
                </div>
                <h1 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-3">
                  最新资讯
                </h1>
                <p className="text-foreground-600 text-sm md:text-base max-w-xl">
                  掌握九游娱乐最新动态，获取游戏攻略、优惠活动和行业前沿资讯
                </p>
              </div>
            </div>
          </section>

          <section className="w-full py-10 bg-background-50">
            <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
              {featuredArticle && activeCategory === 'all' && (
                <Link
                  to={`/article/${featuredArticle.id}`}
                  className="block mb-10 group"
                >
                  <div className="relative rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300">
                    <div className="aspect-[21/9] overflow-hidden">
                      <img
                        src={featuredArticle.image}
                        alt={featuredArticle.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                    <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/30 to-transparent"></div>
                    <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                      <span className="px-2 py-0.5 rounded-md bg-accent-500 text-foreground-950 text-xs font-semibold mb-3 inline-block">
                        置顶推荐
                      </span>
                      <h2 className="text-xl md:text-2xl font-bold text-background-50 mb-2 group-hover:text-accent-300 transition-colors">
                        {featuredArticle.title}
                      </h2>
                      <p className="text-background-300 text-sm line-clamp-2 max-w-2xl">
                        {featuredArticle.summary}
                      </p>
                      <div className="flex items-center gap-4 mt-3 text-xs text-background-400">
                        <span>{featuredArticle.publishDate}</span>
                        <span>{featuredArticle.readCount} 阅读</span>
                      </div>
                    </div>
                  </div>
                </Link>
              )}

              <div className="flex items-center flex-wrap gap-2 mb-8">
                {articleCategories.map((cat) => (
                  <button
                    key={cat.id}
                    onClick={() => setActiveCategory(cat.id)}
                    className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                      activeCategory === cat.id
                        ? 'bg-primary-500 text-background-50'
                        : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                    }`}
                  >
                    {cat.name}
                  </button>
                ))}
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {filteredArticles.map((article) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.id}`}
                    className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300 transition-all duration-300"
                  >
                    <div className="aspect-[16/9] overflow-hidden">
                      <img
                        src={article.image}
                        alt={article.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                    <div className="p-5">
                      <div className="flex items-center gap-3 mb-3">
                        <span className="px-2 py-0.5 rounded-md bg-accent-100 text-accent-700 text-xs font-medium">
                          {article.categoryName}
                        </span>
                        <span className="text-xs text-foreground-500">{article.publishDate}</span>
                      </div>
                      <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2.5">
                        {article.title}
                      </h3>
                      <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed mb-3">
                        {article.summary}
                      </p>
                      <div className="flex items-center gap-1 text-xs text-foreground-500">
                        <i className="ri-eye-line"></i>
                        {article.readCount} 阅读
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}